import { IColumn } from "@fluentui/react";
import { HelperService } from "../../../services/helper.service";
import { attributes } from "./cargolist.type";

const helperService: HelperService = HelperService.getInstance();

export const columns: IColumn[] = [
  {
    key: helperService.makeId(10),
    name: "Ansehen",
    fieldName: "edit",
    minWidth: 60,
    maxWidth: 70,
  },
  {
    key: helperService.makeId(10),
    name: attributes.tour.label,
    fieldName: attributes.tour.name,
    minWidth: 70,
    maxWidth: 110,
    isRowHeader: true,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.displayNumber.label,
    fieldName: attributes.displayNumber.name,
    minWidth: 70,
    maxWidth: 110,
    isRowHeader: true,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },

  {
    key: helperService.makeId(10),
    name: attributes.sent.label,
    fieldName: attributes.sent.name,
    minWidth: 70,
    maxWidth: 110,
    isRowHeader: true,
    isResizable: true,
    data: "boolean",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.date.label,
    fieldName: attributes.date.name,
    isSortedDescending: true,
    minWidth: 70,
    maxWidth: 110,
    isResizable: true,
    data: "date",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.address.label,
    fieldName: attributes.address.name,
    minWidth: 70,
    maxWidth: 400,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.vehicle.label,
    fieldName: attributes.vehicle.name,
    minWidth: 70,
    maxWidth: 110,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.trailer.label,
    fieldName: attributes.trailer.name,
    minWidth: 70,
    maxWidth: 110,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.loadingLocation.label,
    fieldName: attributes.loadingLocation.name,
    minWidth: 70,
    maxWidth: 110,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
];
